<div class="flex h-screen w-screen flex-wrap content-center justify-center p-5">
  <div class="flex-col items-center text-center">
    <img
      class="mx-auto mb-10 w-[200px]"
      src="../../../assets/logo.svg"
      alt="Logo" />
    <div class="mb-5 text-lg text-gray-700">
      Company does not registered. Contact our sales department to register your
      company!
    </div>
  </div>
</div>
